import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as TagActions from '../_actions/tag';
import { Tag } from '../_models/tag';

export interface TagState extends EntityState<Tag> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Tag> = createEntityAdapter<Tag>();

const initialState: TagState = adapter.getInitialState({
  loading: false,
  error: null,
});

const tagReducer = createReducer(
  initialState,

  on(TagActions.loadTags, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(TagActions.loadTagsSuccess, (state, { tags }) =>
    adapter.setAll(tags, { ...state, loading: false })
  ),

  on(TagActions.loadTagsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(TagActions.addTagSuccess, (state, { tag }) => adapter.addOne(tag, state)),

  on(TagActions.updateTagSuccess, (state, { tag }) => adapter.upsertOne(tag, state)),

  on(TagActions.deleteTagSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    TagActions.addTagFailure,
    TagActions.updateTagFailure,
    TagActions.deleteTagFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: TagState | undefined, action: Action) {
  return tagReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
